import PageHeader from "./pageHeader"
import { FormControl } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';

export default function MenuHeader({headTitle,dateValue,onChangeDate,onClickFilter}){
    return(
        <div className='page_wrap fixed-top py-2' style={{backgroundColor:'#ffffff', height:250}}>
            <div className='row'>
                <div className='col-12 pt-5'>
                    <PageHeader title={headTitle} style={{fontSize : '1.25rem', fontWeight : '600'}} is_back_btn={true} />
                    <div className='custom-tabs-bg-solusiqu mt-2'>
                        <div className='mb-5 pt-3 px-4'>
                            <div className='pb-3' style={{textAlign:'center'}}>
                                <h6>Filter</h6>
                            </div>
                            <FormControl className='col-12' sx={{mb:'5px'}}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <MobileDatePicker
                                        label="Periode"
                                        value={dateValue}
                                        size='small'
                                        views={['month','year']}
                                        onChange={onChangeDate}
                                        sx={{
                                            "& .MuiInputBase-input": {
                                                height: '0.35em',
                                                display: 'inline'
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                            <button className='btn btn-primary rounded float-right' 
                                    onClick={onClickFilter}
                            >Check
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}